import PropTypes from 'prop-types';
import React from 'react';

import {
  TextField as RawTextField,
  Label,
  Input,
  Message,
} from '@zendeskgarden/react-textfields';

const TextField = props => (
  <RawTextField>
    <Label>{props.label}</Label>
    <Input
      type={props.type}
      validation={props.validation ? 'error' : 'none'}
      id={props.id}
      onChange={props.onChange}
      value={props.value}
    />
    {props.validation && (
      <Message validation="error">{props.validation}</Message>
    )}
  </RawTextField>
);

TextField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.string,
  validation: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default TextField;
